import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { SkyClubTrackerService } from '../../services/api/skyclub-tracker.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class SkyClubTrackerEffects {
  loadSkyClubTrackerData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadSkyClubTracker),
      switchMap(() =>
        combineLatest([
          this.overview.flags$.pipe(
            filter((flags) => flags !== undefined),
            take(1)
          ),
          this.overview.skyclubRequest$.pipe(
            filter((skyclubRequest) => skyclubRequest !== undefined),
            take(1)
          ),
          this.overview.serviceConfiguration$.pipe(
            filter(
              (serviceConfiguration) => serviceConfiguration !== undefined
            ),
            take(1)
          )
        ]).pipe(
          switchMap(([flags, skyclubRequest, serviceConfiguration]) => {
            if (
              flags &&
              flags.skyclub &&
              skyclubRequest.affiliationList.length > 0
            ) {
              return this.skyclub
                .getSkyClubTrackerVisit(serviceConfiguration, skyclubRequest)
                .pipe(
                  map((content) =>
                    OverviewActions.loadSkyClubTrackerSuccess({
                      skyClubTracker: {
                        id: 'skyclub-tracker-content',
                        skyclubTrackerData: content
                      }
                    })
                  ),
                  catchError((error: HttpErrorResponse) => {
                    this.dataLayer.setErrorData(error);
                    this.analyticsService.dispatchCustomEvent<string>(
                      'error-triggered:SkyClubTracker',
                      ''
                    );
                    return of(
                      OverviewActions.loadSkyClubTrackerFailure({
                        error: {
                          id: 'skyclub-tracker-content-error',
                          skyclubTrackerDataError: 'skyclub-tracker'
                        }
                      })
                    );
                  })
                );
            } else {
              return of(
                OverviewActions.loadSkyClubTrackerSuccess({
                  skyClubTracker: {
                    id: 'skyclub-tracker-content',
                    skyclubTrackerData: { visitRecord: [] }
                  }
                })
              );
            }
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly skyclub: SkyClubTrackerService,
    private readonly overview: OverviewFacade,
    private analyticsService: AnalyticsService,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
